const redirects = (t) => {
  {
    const routes = [
      {
        path: '/',
        redirectPath: t('routes.home'),
      },
      {
        path: `${t('routes.emailVerify')}/:changeFlow?`,
        redirectPath: t('routes.sitesPage'),
      },
      {
        path: `${t('routes.phoneVerify')}/:changeFlow?`,
        redirectPath: t('routes.home'),
      },
      {
        path: t('routes.onboarding'),
        redirectPath: t('routes.home'),
      },
      {
        path: t('routes.persona'),
        redirectPath: t('routes.home'),
      },
      {
        path: t('routes.newSite'),
        redirectPath: t('routes.home'),
      },
      {
        path: t('routes.invoices'),
        redirectPath: `${t('routes.invoices')}${t('routes.unpaid')}`,
      },
      {
        path: t('routes.helpRedirect'),
        redirectPath: t('routes.help'),
      },
      {
        path: `${t('routes.helpRedirect')}${t('routes.supportforms')}`,
        redirectPath: `${t('routes.help')}${t('routes.supportforms')}`,
      },
      {
        path: 'non existant path -- force logic',
        redirectPath: t('routes.myData'),
      },
    ];

    routes.push();

    return routes;
  }
};

export default redirects;
